import { render } from "./Index.vue?vue&type=template&id=f01ddfa4"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "f01ddfa4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f01ddfa4', script)) {
    api.reload('f01ddfa4', script)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=f01ddfa4", () => {
    api.rerender('f01ddfa4', render)
  })

}

script.__file = "resources/js/Pages/Media/Index.vue"

export default script